// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { 
  FileText, 
  Search, 
  Filter, 
  Clock, 
  CheckCircle, 
  XCircle, 
  AlertCircle, 
  Edit3,
  Ban,
  Eye,
  Building2,
  ChevronLeft,
  ChevronRight,
  Archive
} from "lucide-react";

import { collection, query, orderBy, onSnapshot, getDocs } from "firebase/firestore";
import { db } from "../../config/firebase";

const AdminSolicitacoesPage = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filtroImobiliaria, setFiltroImobiliaria] = useState("");
  
  // 🟢 States de Paginação (Client-side DOM Virtualization)
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  
  const brandColor = "#00a99d";

  useEffect(() => {
    setLoading(true);

    const q = query(
      collection(db, "requests"),
      orderBy("createdAt", "desc")
    );

    const unsubscribe = onSnapshot(q, async (snapshot) => {
      try {
        const fetchPromises = snapshot.docs.map(async (docSnapshot) => {
          const requestData = docSnapshot.data();
          const partesRef = collection(db, `requests/${docSnapshot.id}/partes`);
          const partesSnap = await getDocs(partesRef);
          
          // Filtra apenas as partes que são "Locatário" e extrai o nome
          const locatarios = partesSnap.docs
            .map(p => p.data())
            .filter(p => p.dadosPessoais?.pretendenteA === "Locatário")
            .map(p => p.dadosPessoais?.nome);

          return {
            id: docSnapshot.id,
            ...requestData,
            locatarios
          };
        });

        const resolvedDocs = await Promise.all(fetchPromises);
        setRequests(resolvedDocs);
      } catch (error) {
        console.error("Erro ao buscar as partes das requests:", error);
      } finally {
        setLoading(false);
      }
    }, (error) => {
      console.error("Erro ao buscar os requests:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // 🟢 Reseta a página para 1 sempre que um filtro ou limite de itens for alterado
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filtroImobiliaria, itemsPerPage]);

  const renderStatusBadge = (status) => {
    const badges = {
      "Em Cadastramento": { color: "bg-slate-100 text-slate-700 border-slate-200", icon: Edit3 },
      "Em Analise": { color: "bg-blue-100 text-blue-700 border-blue-200", icon: Clock },
      "Pendente": { color: "bg-yellow-100 text-yellow-800 border-yellow-300", icon: AlertCircle },
      "Aprovada": { color: "bg-emerald-100 text-emerald-800 border-emerald-300", icon: CheckCircle },
      "Garantia Ativa": { color: "bg-green-600 text-white border-green-700 shadow-sm", icon: CheckCircle },
      "Rejeitada": { color: "bg-red-100 text-red-700 border-red-200", icon: XCircle },
      "Cancelada Cliente": { color: "bg-slate-100 text-slate-500 border-slate-200 line-through decoration-slate-400", icon: Ban },
      "Legado": { color: "bg-purple-100 text-purple-700 border-purple-200", icon: Archive },
      "LEGADO": { color: "bg-purple-100 text-purple-700 border-purple-200", icon: Archive },
    };

    const config = badges[status] || badges["Em Analise"];
    const Icon = config.icon;

    return (
      <span className={`inline-flex items-center px-2.5 py-1 text-[10px] xl:text-xs font-bold rounded-full border ${config.color} whitespace-nowrap`}>
        <Icon className="w-3 h-3 xl:w-3.5 xl:h-3.5 mr-1.5" />
        {status}
      </span>
    );
  };

  const imobiliariasUnicas = Array.from(new Set(requests.map(req => req.companyName).filter(Boolean)));

  const requestsFiltrados = requests.filter(req => {
    const matchBusca = (
      req.protocolo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      req.companyName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      req.imovel?.codigo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      req.imovel?.endereco?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      req.locatarios?.some(nome => nome?.toLowerCase().includes(searchTerm.toLowerCase())) // Busca por nome do locatário
    );
    
    const matchImobiliaria = filtroImobiliaria ? req.companyName === filtroImobiliaria : true;

    return matchBusca && matchImobiliaria;
  });

  // 🟢 Lógica de Fatiamento para a Tabela (Paginação)
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = requestsFiltrados.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(requestsFiltrados.length / itemsPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(prev => prev + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(prev => prev - 1);
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-6 animate-fade-in bg-slate-50 min-h-screen font-sans overflow-x-hidden w-full">
      
      {/* HEADER */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 border-b border-slate-100 pb-6">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-teal-50 flex items-center justify-center shrink-0 border border-teal-100/50">
            <FileText className="w-6 h-6 md:w-7 md:h-7" style={{ color: brandColor }} />
          </div>
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-slate-800">
              Caixa de Entrada (Solicitações)
            </h1>
            <p className="text-sm sm:text-base text-slate-500 mt-0.5">
              Gestão e análise de todas as Solicitações enviadas pelas imobiliárias parceiras.
            </p>
          </div>
        </div>
      </div>

      {/* ÁREA DE LISTAGEM */}
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm flex flex-col w-full overflow-hidden">
        
        {/* BARRA DE FILTROS */}
        <div className="p-4 sm:p-5 border-b border-slate-200 flex flex-col md:flex-row justify-between items-center gap-4 bg-white shrink-0">
          <div className="flex flex-col md:flex-row gap-3 w-full">
            <div className="relative flex-1 w-full">
              <Search className="w-4 h-4 absolute left-3 top-3.5 text-slate-400" />
              <input 
                type="text" 
                placeholder="Pesquisar por locatário, imobiliária, protocolo..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-9 pr-4 py-3 sm:py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-[#00a99d] focus:ring-1 focus:ring-[#00a99d] text-slate-800 transition-all placeholder-slate-400"
              />
            </div>
            <div className="relative w-full md:w-64 shrink-0">
              <Building2 className="w-4 h-4 absolute left-3 top-3.5 text-slate-400 pointer-events-none" />
              <select 
                value={filtroImobiliaria}
                onChange={(e) => setFiltroImobiliaria(e.target.value)}
                className="w-full pl-9 pr-4 py-3 sm:py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-[#00a99d] focus:ring-1 focus:ring-[#00a99d] text-slate-800 transition-all appearance-none cursor-pointer"
              >
                <option value="">Todas as Imobiliárias</option>
                {imobiliariasUnicas.map((nome, idx) => (
                  <option key={idx} value={nome}>{nome}</option>
                ))}
              </select>
            </div>
            <button className="flex items-center justify-center w-full md:w-auto px-6 py-3 sm:py-2.5 border border-slate-200 rounded-xl bg-white hover:bg-slate-50 text-slate-600 transition-colors text-sm font-bold gap-2 shrink-0 shadow-sm">
              <Filter className="w-4 h-4" /> Filtros
            </button>
          </div>
        </div>

        {/* TABELA BLINDADA & SKELETON LOADER */}
        <div className="w-full min-h-[300px] flex flex-col bg-slate-50 lg:bg-white overflow-x-auto custom-scrollbar">
          {loading ? (
            // 🟢 Skeleton Loader Padrão FIFA
            <div className="flex-1 w-full animate-pulse p-4 lg:p-0">
              <div className="hidden lg:flex bg-slate-50 border-b border-slate-200 h-14"></div>
              {Array(6).fill(0).map((_, i) => (
                <div key={i} className="flex flex-col lg:flex-row justify-between lg:items-center p-4 lg:py-4 lg:px-6 border-b border-slate-100 bg-white mb-4 lg:mb-0 rounded-xl lg:rounded-none">
                  <div className="h-4 bg-slate-200 rounded w-24 mb-3 lg:mb-0"></div>
                  <div className="space-y-2 lg:w-48 mb-3 lg:mb-0"><div className="h-4 bg-slate-200 rounded w-3/4"></div><div className="h-3 bg-slate-100 rounded w-1/2"></div></div>
                  <div className="space-y-2 lg:w-48 mb-3 lg:mb-0"><div className="h-4 bg-slate-200 rounded w-3/4"></div><div className="h-3 bg-slate-100 rounded w-2/3"></div></div>
                  <div className="space-y-2 lg:w-40 mb-3 lg:mb-0"><div className="h-4 bg-slate-200 rounded w-3/4"></div></div>
                  <div className="h-4 bg-slate-200 rounded w-24 mb-3 lg:mb-0"></div>
                  <div className="h-6 bg-slate-200 rounded-full w-24 mb-4 lg:mb-0"></div>
                  <div className="h-10 lg:h-8 bg-slate-200 rounded w-full lg:w-10"></div>
                </div>
              ))}
            </div>
          ) : currentItems.length === 0 ? (
            <div className="flex-1 flex flex-col items-center justify-center p-12 text-center bg-white">
              <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mb-4 border border-slate-100">
                <FileText className="w-8 h-8 text-slate-300" />
              </div>
              <p className="text-slate-800 font-bold text-lg">Nenhuma Solicitação encontrada.</p>
              <p className="text-sm text-slate-500 mt-1">Sua base de dados parece estar vazia ou a pesquisa não retornou resultados nesta página.</p>
            </div>
          ) : (
            <table className="w-full text-left border-collapse block lg:table table-fixed">
              <thead className="hidden lg:table-header-group">
                <tr className="bg-slate-50 border-b border-slate-200 text-[11px] uppercase text-slate-500 font-black tracking-wider">
                  <th className="px-4 py-4 pl-6 w-[120px] xl:w-[140px]">Nº Protocolo</th>
                  <th className="px-4 py-4 w-[180px] xl:w-[220px]">Imobiliária</th>
                  <th className="px-4 py-4">Endereço (Imóvel)</th>
                  <th className="px-4 py-4 w-[160px] xl:w-[180px]">Locatários</th>
                  <th className="px-4 py-4 w-[110px] xl:w-[130px]">Data Envio</th>
                  <th className="px-4 py-4 w-[130px] xl:w-[140px]">Situação</th>
                  <th className="px-4 py-4 pr-6 w-[80px] xl:w-[100px] text-center">Ação</th>
                </tr>
              </thead>
              <tbody className="block lg:table-row-group p-4 lg:p-0">
                {currentItems.map((req) => (
                  <tr 
                    key={req.id} 
                    className="block lg:table-row bg-white border border-slate-200 lg:border-0 lg:border-b lg:border-slate-100 rounded-2xl lg:rounded-none mb-4 lg:mb-0 p-4 lg:p-0 shadow-sm lg:shadow-none hover:bg-slate-50 transition-colors group"
                  >
                    <td className="flex flex-col lg:flex-row justify-between items-start lg:items-center lg:table-cell pb-2 mb-2 lg:pb-0 lg:mb-0 border-b border-slate-100 lg:border-none py-3 lg:py-4 pl-4 lg:pl-6 align-middle overflow-hidden">
                      <span className="lg:hidden text-[10px] uppercase font-black text-slate-400 mb-1">Nº Protocolo</span>
                      <span className="font-bold text-slate-800 text-[13px] xl:text-sm truncate block">
                        {req.protocolo || req.numeroSolicitacao || "S/N"}
                      </span>
                    </td>
                    <td className="flex flex-col lg:flex-row justify-between items-start lg:items-center lg:table-cell py-3 lg:py-4 px-4 border-b border-slate-100 lg:border-none align-middle overflow-hidden">
                      <span className="lg:hidden text-[10px] uppercase font-black text-slate-400 mb-1">Imobiliária</span>
                      <div className="flex flex-col text-left w-full" title={req.companyName}>
                        <span className="text-[13px] xl:text-sm font-bold truncate block w-full" style={{ color: brandColor }}>
                          {req.companyName || "Desconhecida"}
                        </span>
                        <span className="text-[11px] text-slate-500 font-medium truncate block w-full mt-0.5" title={`Atend: ${req.createdByName || "-"}`}>
                          Atend: {req.createdByName || "-"}
                        </span>
                      </div>
                    </td>
                    <td className="flex flex-col lg:flex-row justify-between items-start lg:table-cell py-3 lg:py-4 px-4 border-b border-slate-100 lg:border-none align-middle overflow-hidden">
                      <span className="lg:hidden text-[10px] uppercase font-black text-slate-400 mb-1 shrink-0">Endereço (Imóvel)</span>
                      {req.imovel ? (
                        <div className="flex flex-col text-left w-full" title={`${req.imovel.endereco}, ${req.imovel.numero} - ${req.imovel.bairro}`}>
                          <span className="text-slate-800 font-bold text-[13px] xl:text-sm truncate block w-full">
                            {req.imovel.codigo || "-"}
                          </span>
                          <span className="text-[11px] xl:text-xs text-slate-500 truncate block w-full mt-0.5">
                            {req.imovel.endereco}, {req.imovel.numero} - {req.imovel.bairro}
                          </span>
                        </div>
                      ) : (
                        <span className="text-slate-400 text-sm">-</span>
                      )}
                    </td>
                    <td className="flex flex-col lg:flex-row justify-between items-start lg:items-center lg:table-cell py-3 lg:py-4 px-4 border-b border-slate-100 lg:border-none align-middle overflow-hidden">
                      <span className="lg:hidden text-[10px] uppercase font-black text-slate-400 mb-1">Locatários</span>
                      {req.locatarios && req.locatarios.length > 0 ? (
                        <div className="flex flex-wrap items-center gap-1.5 w-full">
                          <span className="text-[13px] xl:text-sm font-bold text-slate-700 truncate max-w-[120px] xl:max-w-[140px]" title={req.locatarios[0]}>
                            {req.locatarios[0]}
                          </span>
                          {req.locatarios.length > 1 && (
                            <span className="text-[10px] bg-teal-50 text-[#00a99d] px-1.5 py-0.5 rounded-full whitespace-nowrap font-bold border border-teal-100 shrink-0">
                              +{req.locatarios.length - 1}
                            </span>
                          )}
                        </div>
                      ) : (
                        <span className="text-slate-400 text-xs italic">Não informado</span>
                      )}
                    </td>
                    <td className="flex flex-row justify-between items-center lg:table-cell py-3 lg:py-4 px-4 border-b border-slate-100 lg:border-none align-middle overflow-hidden">
                      <span className="lg:hidden text-[10px] uppercase font-black text-slate-400">Data Envio</span>
                      <span className="text-xs xl:text-sm font-medium text-slate-600 truncate block">
                        {req.dataSolicitacaoTexto || "-"}
                      </span>
                    </td>
                    <td className="flex flex-row justify-between items-center lg:table-cell py-3 lg:py-4 px-4 border-b border-slate-100 lg:border-none align-middle overflow-hidden">
                      <span className="lg:hidden text-[10px] uppercase font-black text-slate-400">Situação</span>
                      {renderStatusBadge(req.status)}
                    </td>
                    <td className="flex justify-center items-center lg:table-cell pt-4 lg:pt-0 py-3 lg:py-4 pr-4 lg:pr-6 text-center align-middle overflow-hidden">
                      <Link 
                        to={`/super-admin/request/${(req.protocolo || req.numeroSolicitacao)?.replace('/','-')}`} 
                        className="flex lg:inline-flex items-center justify-center w-full lg:w-auto p-3.5 lg:p-2 text-white rounded-xl lg:rounded-lg transition-all shadow-sm hover:shadow-md hover:brightness-110 text-sm font-bold uppercase tracking-wide lg:normal-case lg:tracking-normal" 
                        style={{ backgroundColor: brandColor }}
                        title="Abrir Análise"
                      >
                        <Eye className="w-5 h-5 lg:w-4 lg:h-4 lg:mr-0 mr-1.5" />
                        <span className="lg:hidden">Analisar Ficha</span>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        
        {/* 🟢 CONTROLES DE PAGINAÇÃO VIVOS (FOOTER) */}
        {requestsFiltrados.length > 0 && (
          <div className="p-4 sm:p-5 border-t border-slate-200 bg-white flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500 shrink-0">
            <span className="font-medium text-center md:text-left">
              Mostrando <strong className="text-slate-800">{indexOfFirstItem + 1}</strong> a <strong className="text-slate-800">{Math.min(indexOfLastItem, requestsFiltrados.length)}</strong> de <strong className="text-slate-800">{requestsFiltrados.length}</strong> registros
            </span>
            
            <div className="flex flex-col sm:flex-row items-center gap-4 w-full md:w-auto">
              
              <div className="flex items-center gap-2 bg-slate-50 px-3 py-1.5 rounded-lg border border-slate-200 shadow-sm w-full sm:w-auto justify-center">
                <span className="font-medium">Itens por página:</span>
                <select 
                  value={itemsPerPage}
                  onChange={(e) => setItemsPerPage(Number(e.target.value))}
                  className="bg-transparent border-none font-bold text-[#00a99d] focus:ring-0 cursor-pointer text-sm outline-none"
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>

              {totalPages > 1 && (
                <div className="flex items-center gap-2 justify-center w-full sm:w-auto">
                  <button 
                    onClick={prevPage}
                    disabled={currentPage === 1}
                    className="p-1.5 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-100 disabled:opacity-50 disabled:hover:bg-white transition-colors shadow-sm"
                  >
                    <ChevronLeft className="w-5 h-5" />
                  </button>
                  <span className="text-sm font-bold text-slate-700 px-3 py-1 bg-white border border-slate-200 rounded-lg shadow-sm">
                    {currentPage} / {totalPages}
                  </span>
                  <button 
                    onClick={nextPage}
                    disabled={currentPage >= totalPages}
                    className="p-1.5 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-100 disabled:opacity-50 disabled:hover:bg-white transition-colors shadow-sm"
                  >
                    <ChevronRight className="w-5 h-5" />
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default AdminSolicitacoesPage;